module.exports = "'data:image/svg+xml;utf8,<svg width=\"12\" height=\"7\" viewBox=\"0 0 12 7\" xmlns=\"http://www.w3.org/2000/svg\"><title>arrow</title><path d=\"M9.877.33a1.128 1.128 0 0 1 1.588 0c.443.444.44 1.152.003 1.59L6.69 6.698a1.118 1.118 0 0 1-.79.326 1.104 1.104 0 0 1-.796-.326L.326 1.92A1.128 1.128 0 0 1 .328.33a1.12 1.12 0 0 1 1.59 0l3.98 3.98L9.877.33z\" fill=\"%23C3CDD7\" fill-rule=\"evenodd\"/></svg>'"


/*****************
 ** WEBPACK FOOTER
 ** ./src/SampleToggle/arrowExpanded.svg
 ** module id = 291
 ** module chunks = 0
 **/